import { FC, FunctionComponent} from "react";
import SignInLeft from "../../components/shared-components/signIn/SignInLeft";
import QuickAsystLogo from "../../components/shared-components/signIn/QuickAsystLogo";
import SignInSubTitle from "../../components/shared-components/signIn/SignInSubTitle";
import styles from './AuthLayout.module.css'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { roles } from "../../helper";
import SignInLeftSuperUser from "../../components/shared-components/signIn/SignInLeftSuperUser";

interface ProType {
  component: FunctionComponent;
  role:string ;
}

const AuthLayout: FC<ProType> = ({ component: Component, role }) => {
  return (
    <>
    <div className={role !== roles.SUPER_USER ? styles.QuickAsystApprovalScreen : styles.QuickAsystApprovalScreenSuperUser}>
    <div className={role !== roles.SUPER_USER ? styles.dashboardLayout : styles.dashboardLayoutSuperUser}>
      {role !== roles.SUPER_USER ? <SignInLeft/> :<SignInLeftSuperUser/>}
      <div className={role !== roles.SUPER_USER ? styles.rightPart : styles.rightPartSuperUser}>
        <div className={styles.approvalContainer}>
          <QuickAsystLogo />
          <div className={styles.container}>
            <SignInSubTitle role={role}/>
            <div className={styles.mainContainer}>
            <ToastContainer 
            position="top-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            />
              <Component/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </>
  );
};
export default AuthLayout;
